<script>
  import { session } from '../../lib/session';
  import { OFFER_STATUS } from '../../stores/offers';
  import OfferDetails from './OfferDetails.svelte';
  import StatusBadge from './StatusBadge.svelte';

  export let offer;
  export let onStatusUpdate;
  export let onDelete;
  export let loading = false;

  let expanded = false;

  function formatDate(date) {
    if (!date) return '';
    return new Date(date).toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  }

  $: canModify = $session.user?.id === offer.producerId && offer.status === OFFER_STATUS.SUBMITTED;
</script>

<div class="bg-white rounded-lg shadow-md p-6">
  <div class="flex justify-between items-start mb-4">
    <div>
      <h3 class="text-xl font-semibold text-gray-800">
        Week {offer.weekNumber} Offer
      </h3>
      <p class="text-sm text-gray-600">
        {offer.products.length} product{offer.products.length > 1 ? 's' : ''}
      </p>
      <p class="text-sm text-gray-600">Producer: {offer.producerName}</p>
      {#if offer.weekDates?.[0] && offer.weekDates?.[6]}
        <p class="text-sm text-gray-500">
          {formatDate(offer.weekDates[0])} - {formatDate(offer.weekDates[6])}
        </p>
      {/if}
    </div>
    <div class="flex items-center gap-3">
      <StatusBadge status={offer.status} />
      <button
        on:click={() => expanded = !expanded}
        class="text-gray-600 hover:text-gray-800"
      >
        {expanded ? 'Hide Details' : 'Show Details'}
      </button>
    </div>
  </div>

  {#if expanded}
    <OfferDetails 
      {offer}
      {onStatusUpdate}
      {onDelete}
      {loading}
      {canModify}
    />
  {/if}

  <div class="mt-4 pt-4 border-t text-sm text-gray-500">
    <div>Posted: {new Date(offer.timestamp).toLocaleString()}</div>
    {#if offer.lastModified}
      <div>Last Modified: {new Date(offer.lastModified).toLocaleString()}</div>
    {/if}
  </div>
</div>
